/**
 * Build the filter object for export/getList calls — same merge as react-admin ExportButton.
 * Uses filterValues (tabs, date range, search, etc.) plus any permanent List `filter` prop.
 */
export function getListExportFilter(
  filterValues: Record<string, unknown> | undefined,
  permanentFilter?: Record<string, unknown>
): Record<string, unknown> {
  if (permanentFilter && Object.keys(permanentFilter).length > 0) {
    return { ...(filterValues ?? {}), ...permanentFilter };
  }
  return { ...(filterValues ?? {}) };
}
